<div class="row" *ngIf="inputs.length > 0 && !loading">
    <div class="col-md-8 order-xl-2 mb-5 mb-xl-0 mt-3">
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <div class="card bg-secondary shadow">
                <div class="card-header bg-white border-0">
                    <div class="row align-items-center">
                        <div class="col-6">
                            <h3 class="mb-0">{{ title }}</h3>
                        </div>
                        <div class="col-6 text-right">
                            <button type="submit" class="btn btn-xl btn-warning">Modifier</button>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-12" *ngFor="let item of inputs">
                            <div class="form-group" *ngIf="item.type == 'text'">
                                <label class="form-control-label">{{ item.label }} :</label>
                                <input type="text" class="form-control form-control-alternative"
                                    placeholder="{{ item.label }}" formControlName="{{ item.name }}"
                                    *ngIf="item.readOnly" [ngStyle]="setBorderInput(item.name)" readonly>

                                <input type="text" class="form-control form-control-alternative"
                                    placeholder="{{ item.label }}" formControlName="{{ item.name }}"
                                    *ngIf="!item.readOnly && !item.maxlength" [ngStyle]="setBorderInput(item.name)">

                                <input type="text" class="form-control form-control-alternative"
                                    placeholder="{{ item.label }}" formControlName="{{ item.name }}"
                                    *ngIf="!item.readOnly && item.maxlength" maxlength="{{ item.maxlength }}"
                                    [ngStyle]="setBorderInput(item.name)">

                            </div>
                            <div class="form-group" *ngIf="item.type == 'number'">
                                <label class="form-control-label">{{ item.label }} :</label>
                                <input type="number" class="form-control form-control-alternative"
                                    placeholder="{{ item.label }}" formControlName="{{ item.name }}"
                                    *ngIf="item.readOnly" readonly [ngStyle]="setBorderInput(item.name)">
                                <input type="number" class="form-control form-control-alternative"
                                    placeholder="{{ item.label }}" formControlName="{{ item.name }}"
                                    *ngIf="!item.readOnly" [ngStyle]="setBorderInput(item.name)">
                            </div>
                            <div class="form-group" *ngIf="item.type == 'password'">
                                <label class="form-control-label">{{ item.label }} :</label>
                                <input type="text" class="form-control form-control-alternative"
                                    placeholder="{{ item.label }}" formControlName="{{ item.name }}">
                            </div>
                            <div class="form-group" *ngIf="item.type == 'textarea'">
                                <label class="form-control-label">{{ item.label }} :</label>
                                <ckeditor [editor]="Editor" formControlName="{{ item.name }}"></ckeditor>
                            </div>
                            <div class="form-group" *ngIf="item.type == 'enum'">
                                <label class="form-control-label">{{ item.label }} :</label>
                                <select class="form-control" formControlName="{{ item.name }}" (change)="onSelectChange(item.name,$event)">
                                    <option value="{{ value }}" *ngFor="let value of item.list">{{ value }}</option>
                                </select>
                            </div>
                            <div class="form-group" *ngIf="item.type == 'switch'">
                                <label class="form-control-label">{{ item.label }} :</label>
                                <label class="switch">
                                    <input type="checkbox" formControlName="{{ item.name }}">
                                    <span class="slider round"></span>
                                </label>
                            </div>
                            <div class="form-group" *ngIf="item.type == 'date'">
                                <label class="form-control-label">{{ item.label }} :</label>
                                <div class="input-group">
                                    <input class="form-control" placeholder="yyyy-mm-dd"
                                        formControlName="{{ item.name }}" ngbDatepicker #start="ngbDatepicker" />
                                    <button class="btn btn-studiomap ri fa fa-calendar" (click)="start.toggle()"
                                        type="button"></button>
                                </div>
                            </div>
                            <div class="form-group" *ngIf="item.type == 'file'">
                                <input type="file" class="form-control" (change)="uploadInputsFile(item.name,$event)">
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </form>

    </div>
</div>